<template>
  <div class="form-narrow">
    <div class="form-row">
      <div class="form-col">
        <label class="label">location name</label>
        <div>{{initialValues.locationName}}</div>
      </div>
      <div class="form-col">
        <label class="label">location id</label>
        <div>{{initialValues.locationId}}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-col">
        <label class="label">start date</label>
        <div>{{initialValues.startDate}}</div>
      </div>
      <div class="form-col">
        <label class="label">end date</label>
        <div>{{initialValues.endDate}}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-col">
        <label class="label">type</label>
        <div>{{initialValues.type}}</div>
      </div>
    </div>

    <ModalFooter :footer="footer" :tertiary="cancel" :primary="cancel" />
  </div>
</template>

<script>
  import ModalNavigation from "@/mixins/ModalNavigation";
  import ModalFooter from "@/components/ui/modals/ModalFooter";

  export default {
    name: "LeaseDetails",
    components: {
      ModalFooter,
    },
    mixins: [
      ModalNavigation,
    ],
    props: {
      initialValues: {
        type: Object,
        default: () => ({})
      },
    },
    data(){
      return {
        footer: {
          tertiaryButton: 'back'
        },
      }
    },
    methods: {
      cancel(e) {
        e.preventDefault();
        this.close();
      },
    },
  }
</script>
<style scoped>

</style>
